module.exports = __webpack_public_path__ + "media/conmex/gestion-fbac4ad5.png";